"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const MuiMenuOverrides = {
    MuiMenu: {
        styleOverrides: {
            root: () => ({
                maxHeight: '306px',
            }),
        },
    },
};
exports.default = MuiMenuOverrides;
//# sourceMappingURL=MuiMenuOverrides.js.map